import { render, staticRenderFns } from "./SpaceStorage.vue?vue&type=template&id=156dee3b&"
import script from "./SpaceStorage.vue?vue&type=script&lang=js&"
export * from "./SpaceStorage.vue?vue&type=script&lang=js&"
import style0 from "./SpaceStorage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports